// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { storePickupStyles } from "@insite/content-library/Widgets/StorePickupOverlay/StorePickup";
import { RadioStyle } from "@insite/mobius/Radio";
import { css } from "styled-components";

storePickupStyles.distanceUnitOfMeasureRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        & > div {
            display: inline-flex;
            margin-left: 5px;
        }
        padding-top: 25px;
        ${RadioStyle} {
            margin-left: 20px;
        }
        ${RadioStyle} + ${RadioStyle} {
            margin-top: 0;
        }
    `,
};

storePickupStyles.searchResultWarehouseAvailabilityGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
    `,
};
